import {Button, Grid, TextField} from "@mui/material";
import {useEffect, useState} from "react";
import {API} from "../framework/api";
import {isAdministrator} from "../framework/utils";
import {Menu} from "../component/Menu";
import {MENU_ITEMS} from "../framework/constants";
import {CompetenceArea} from "../component/CompetenceArea";
import {ReplyArea} from "../component/ReplyArea";
import {AssignmentReplies} from "../component/AssignmentReplies";

export function AdminSearchPage(props) {

  const [values, setValues] = useState({
    competences: '',
    search: '',
  });
  const [searchResult, setSearchResult] = useState([]);
  const [searchResultUsers, setSearchResultUsers] = useState([]);

  useEffect(() => {
  }, []);


  if (!isAdministrator()) {
    document.location.hash = "#/anslagstavlan";
    return;
  }

  const handleChange = (event, prop) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const updateCompetences = (id, hasIt) => {
    let sep = "";
    let cStr = "";

    let comp = {};
    values.competences.split(",").forEach((c) => {
      if (parseInt(c) !== parseInt(id)) comp[parseInt(c)] = true;
    });

    if (hasIt) {
      comp[parseInt(id)] = true;
    }

    Object.keys(comp).forEach(k => {
      cStr += sep + k;
      sep = ',';
    });
    setValues({ ...values, competences: cStr });
  }

  const handleSearch = () => {
    API.getAPI().admin_search(values).then((response) => {
      setSearchResult(response.data.assignments);
      setSearchResultUsers(response.data.users);
    });
  }

  return (
    <div>
      <div className={"App-title-withSubtitle"}>Anslagstavlan [ADMIN]</div>
      <div className={"App-subTitle"}>Funktioner för administratörer.</div>
      <Grid container={true} spacing={0} className={"App-drop-shadow"}>
        <Grid item xs={3} sm={3} className={"App-container-leftMenu"}>
          <Menu items={MENU_ITEMS} />
        </Grid>
        <Grid item xs={9} sm={9} className={"App-container-rightContent"}>
          <div className={"App-rightContent"}>
            <Grid container={true} spacing={0}>

              {/*** App Right content ***/}

              <Grid item xs={12} sm={12}>
                <div className={"App-fieldTitle"}>Välj kunskaper att filtrera på</div>
              </Grid>
              <Grid item xs={12} sm={12}>

                {/*** Competences ***/}
                <CompetenceArea competences={values.competences} onChange={(id, hasIt) => { updateCompetences(id, hasIt) }} />

              </Grid>
              <Grid item xs={12} sm={12} className={"u-marginT8"}>

                <TextField
                  fullWidth={1}
                  type="text"
                  id="outlined-basic"
                  label="Sök..."
                  variant="outlined"
                  value={values.search}
                  onChange={(e)=> handleChange(e, 'search')}
                />
              </Grid>

              <Grid item xs={12} sm={12} className={"u-textRight u-marginT20"}>

                <Button
                  className={"App-button-contained"}
                  variant={"contained"}
                  onClick={() => { handleSearch() }}
                >
                  Sök
                </Button>
              </Grid>

            </Grid>
          </div>
          <Grid container={1} spacing={0}>
            <Grid item xs={12} md={12}>
              {searchResultUsers.length > 0 ?
                <div className={"App-rightContent u-paddingT10"}>
                  {searchResultUsers.map(user => (
                    <span className={"App-fieldTitle u-marginR10 u-marginB10 u-clickable"} onClick={() => { document.location.hash="#/admin-profile/" + user; }}>{user}</span>
                  ))}
                </div> : null}
            </Grid>
          </Grid>
          <Grid container={1} spacing={0}>
            {searchResult.map(result => (
              <Grid item xs={12} md={12}>
                <div className={"App-rightContent"}>
                  <Grid container={1} spacing={1}>
                    <Grid item xs={8} md={8}>
                      <div className={"App-fieldTitle"}><span className={"u-clickable"} onClick={() => { document.location.hash="#/admin-profile/" + result.username; }}>{result.username}</span></div>
                    </Grid>
                    <Grid item xs={4} md={4}>
                      <div className={"u-textRight u-fontSize12 u-paddingT10 u-colorDimmed"}>Inlagd: {result.createdAt}</div>
                    </Grid>
                  </Grid>
                  <div>{result.assignmentText}</div>
                  <div>
                    <AssignmentReplies replies={result.replies} />
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
